<template>
  <div v-if="!connected" class="wrong-network">
    <h2>Mint is only available for the connected wallet!</h2>
    <h2>Please, connect web to Your metamask wallet by the connect button</h2>
  </div>
  <div v-if="connected">
    <div class="wrong-network" v-if="!correctNetwork">
      <h2>Sorry !</h2>
      <h2>
        You are connected to the wrong network! If You want to mint Lemurians,
        please connect to the ethereum main network.
      </h2>
    </div>
    <div v-if="correctNetwork" id="mint" class="mint">
      <div class="mint-count">
        <img class="lemurian image" src="../assets/websitegif.gif" />
        <div class="minted">{{ minted }}/{{ total }} minted</div>
      </div>
      <div class="mint-form">
        <span class="mint-title">Mint Yours:</span>
        <div class="mint-option">
          <a class="mint-btn" v-on:click="mint(1)">
            <img class="image" src="../assets/5aMint1Button.png"
          /></a>
          <span class="mint-title" style="color: #38fab8"
            >{{ this.cost / 1000000000000000000 }} ETH</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Web3EthContract from "web3-eth-contract";
import abi from "@/components/json/abi.json";
import Configuration from "../configuration.json";

const { ethereum } = window;
const smartContract = new Web3EthContract(
  abi,
  Configuration.smartContractAddress
);

export default {
  name: "Mint",
  data: () => ({
    minted: 0,
    total: 8888,
    const: 0,
    correctNetwork: false,
    cost: 0,
  }),
  computed: {
    connected() {
      const connected = this.$store.getters.getConnected;

      if (connected) {
        console.log("after connected");
        this.walletConncted();
      }

      return connected;
    },
  },
  methods: {
    async walletConncted() {
      this.total = await smartContract.methods.maxSupply().call();
      this.minted = await smartContract.methods.totalSupply().call();
      this.cost = await smartContract.methods.cost().call();

      const networkId = await ethereum.request({
        method: "net_version",
      });

      this.correctNetwork = networkId == Configuration.network;

      this.$forceUpdate();
    },
    async mint(count) {
      const accounts = await ethereum.request({
        method: "eth_requestAccounts",
      });
      const address = accounts[0];
      const calculatedCost = this.cost * count;
      console.log(address);
      console.log(calculatedCost);
      console.log(abi.mint);
      smartContract.methods
        .mint(address, count)
        .send({ from: address, value: calculatedCost, gasLimit: "285000" })
        .on("recipt", () => window.reload());
    },
  },
};
</script>

<style lang="scss">
.wrong-network {
  text-align: center;
  margin-top: 50px;
  margin-right: 100px;
  margin-left: 100px;
}

.wrong-network > h2 {
  font-family: Phenomenopolisb;
  font-size: 64px;
  color: #b3e8ff;
}

.mint-btn {
  cursor: pointer;
}

.mint-btn:hover {
  opacity: 0.9;
}

.mint-count {
  margin-top: 60px;
  margin-left: 60px;
}

.minted {
  text-align: center;
  width: 100%;
  font-family: Phenomenopolisb;
  font-size: 64px;
  color: #b3e8ff;
}

.mint {
  display: flex;
  font-weight: bold;
}

.mint-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 50px;
  margin-left: 90px;
}

.btn-1eth {
  background-image: url("../assets/5aMint1Button.png");
}

.mint-form {
  margin-top: 50px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  gap: 16px;
}

.mint-title {
  color: #91a791;
  font-family: Phenomenopolisb;
  font-size: 64px;
  width: 100%;
  text-align: center;
}

@media only screen and (max-width: 768px) {
  .mint {
    flex-direction: column;
    justify-content: center;
    align-content: center;
    width: 100%;
  }

  .lemurian {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
  }

  .mint-option {
    flex-direction: column;
    margin-left: 0px;
    gap: 0px;
  }

  .mint-count {
    margin-left: 0px;
    margin-top: 0px;
  }
}
</style>
